<template>
    <div class="month-alert mb-3 px-1 pt-3 pb-2" :class="`alert-${alert.status}`">
        <div
            class="alert-body d-flex justify-content-between"
            style="border-bottom: solid 1px #8f8f8f"
        >
            <div class="p-2">
                <h4 class="font-weight-bold mr-2">{{ alert.sub_category }}</h4>
                <p>
                    <span style="color: cornflowerblue;">{{ alert.user }} </span>{{ alert.message }}
                </p>
            </div>
            <div class="d-flex justify-content-center align-items-center pr-3">
                <select class="form-control form-control-sm mr-3" v-model="alert.status">
                    <option value="1">High alert</option>
                    <option value="2">Medium alert</option>
                    <option value="3">Low Alert</option>
                    <option value="4">Pending</option>
                    <option value="5">Resolved</option>
                </select>
                <a class="btn btn-primary btn-sm text-uppercase font-weight-bold text-white"
                    >Save</a
                >
            </div>
        </div>
        <div class="alert-footer d-flex justify-content-start p-2">
            <span style="color: #8f8f8f" class="mr-4"
                ><i
                    :class="alertType[alert.status].icon"
                    :style="`color: ${alertType[alert.status].color}`"
                    class="fa"
                ></i
                >&nbsp;{{ alertType[alert.status].text }}{{ alert.category }}</span
            >
            <span style="color: #8f8f8f" class="mr-4"
                ><i class="fa fa-calendar"></i>&nbsp;Alert Started:
                {{ moment(alert.alert_started).format("DD MMM") }}&nbsp;({{
                    moment(alert.alert_due).fromNow()
                }})</span
            >
            <span style="color: #8f8f8f"
                ><i class="fa fa-user"></i>&nbsp;Assigned to: {{ alert.assigned_to }} &nbsp;<i
                    class="fa fa-arrow-circle-o-right text-primary"
                ></i
            ></span>
        </div>

        <i class="fa-che"></i>
    </div>
</template>

<script>
export default {
    name: "CenterMonthAlert",
    props: ["alert"],
    data() {
        return {
            alertType: [
                {},
                { icon: "fa-exclamation-circle", color: "#dc3545", text: "RED ALERT: " },
                { icon: "fa-exclamation-triangle", color: "#ffc107", text: "YELLOW ALERT: " },
                { icon: "fa-exclamation-circle", color: "#007bff", text: "BLUE ALERT: " },
                { icon: "fa-question-circle", color: "#fd7e14", text: "PENDING: " },
                { icon: "fa-check-circle", color: "#28a745", text: "COMPLETED: " },
            ],
        };
    },
};
</script>

<style scoped lang="scss">
.month-alert {
    width: 100%;
    background-color: white;
    box-shadow: 2px 2px 2px 2px #8f8f8f;
}
.alert-1 {
    border-left: solid 5px #dc3545;
}
.alert-2 {
    border-left: solid 5px #ffc107;
}
.alert-3 {
    border-left: solid 5px #007bff;
}
.alert-4 {
    border-left: solid 5px #fd7e14;
}
.alert-5 {
    border-left: solid 5px #28a745;
}
</style>
